import * as z from "zod";

export const getMetaLeadAdsWebhookStatus = {
  name: "getMetaLeadAdsWebhookStatus" as const,
  input: z.object({ pageId: z.string() }),
  output: z.object({ isSubscribed: z.boolean() }),
};
